define(function(require) {
    const BaseFormView = require('./BaseForm.view');
    const GridFiltersTemplate = require('./GridFilters.template.html');
    const _ = require('underscore');
    const Backbone = require('backbone');
    const Select = require('components/Select');
    const ButtonToggleGroup = require('components/ButtonToggleGroup.view');
    require('./GridFilters.css');

    const GridFiltersView = BaseFormView.extend(
        {
            template: _.template(GridFiltersTemplate),

            defaults: function() {
                return {
                    model: new Backbone.Model(),
                    settingsModel: new Backbone.Model(),
                    settingsForm: undefined
                };
            },

            events: {},

            initialize: function(options) {
                const self = this;

                _.extend(self, self.defaults(), options);

                // Use the collection's query params as the source of truth for initial values
                this.syncModel();
                this.listenTo(this.collection, 'QueryParam:Change', this.syncModel);

                _.every(this.form, formElement => {
                    formElement.validate = false;
                });

                this.listenTo(this.model, 'change', (model, options) => {
                    const changed = model.changedAttributes();
                    for (const key in changed) {
                        const binding = this.form.find(field => field.name === key);
                        if (model.get(key)) {
                            if (binding && _.isFunction(binding.setParam)) {
                                binding.setParam(model.get(key), model);
                            } else {
                                this.collection.setParam(key, model.get(key));
                            }
                        } else {
                            if (binding && _.isFunction(binding.setParam)) {
                                binding.setParam(model.get(key), model);
                            } else {
                                this.collection.unsetParam(key);
                            }
                        }
                    }
                    this.collection.getFirstPage({
                        reset: true,
                        fetch: true,
                        traditional: true // Multiple values do not have the brackets (eg. Prevent labelId[]: <value>)
                    });
                });

                Backbone.Validation.bind(this);
            },

            syncModel: function() {
                for (const name of _.pluck(this.form, 'name')) {
                    const queryParamValue = this.collection.getParam(name);
                    if (queryParamValue || queryParamValue === '') {
                        this.model.set(name, queryParamValue);
                    }
                }
            },

            render: function() {
                const self = this;
                const viewOptions = {
                    hasSettings: this.settingsForm?.length > 0
                };

                self.$el.html(this.template(viewOptions));
                self.renderForm('.app-gridfilters__form');
                this.renderForm('.app-gridsettings__form', this.settingsForm, this.settingsModel);

                return self;
            }
        },
        {
            RadioFilter: function(options = {}) {
                if (!options.name) {
                    throw 'name is required';
                }

                if (!options.label) {
                    throw 'label is required';
                }
                return Object.assign(
                    {
                        type: 'component',
                        validate: false,
                        componentOptions: attribute => {
                            return {
                                ViewClass: ButtonToggleGroup,
                                toggleType: 'radio',
                                layoutClass: 'flex-column',
                                buttonOptions: new Backbone.Collection(
                                    this.collection.getOptionsForQueryParam(options.name)
                                )
                            };
                        }
                    },
                    options
                );
            },
             SelectFilter: function(options = {}) {
                if (!options.name) {
                    throw 'name is required';
                }

                if (!options.label) {
                    throw 'label is required';
                }
                return Object.assign(
                    {
                        type: 'component',
                        validate: false,
                        componentOptions: attribute => {
                            return {
                                 ViewClass: Select,
                                setValueOnInitialize: true,
                                allowClear: false,
                                listCollection: new Backbone.Collection(this.collection.queryParamMap[options.name].options),
                                checkApi: false,
                                placeholder: 'Select One',
                                width: '100%',
                                checkMaxResults: false
                            };
                        }
                    },
                    options
                );
            },
            CheckboxFilter: function(options = {}) {
                if (!options.name) {
                    throw 'name is required';
                }

                if (!options.label) {
                    throw 'label is required';
                }
                return Object.assign(
                    {
                        type: 'component',
                        validate: false,
                        componentOptions: attribute => {
                            return {
                                ViewClass: ButtonToggleGroup,
                                toggleType: 'checkbox',
                                changeValueType: 'group',
                                layoutClass: 'flex-column',
                                buttonOptions: new Backbone.Collection(
                                    this.collection.getOptionsForQueryParam(options.name)
                                )
                            };
                        }
                    },
                    options
                );
            }
        }
    );

    return GridFiltersView;
});
